import React, { Component } from "react";
import './tmc.css';
export default class Tmc extends Component {
  render() {
      return (
        <div className="aboutus-secondsec">
      <div className="aboutus-item-container " id="terms">
        <h1>Terms & Conditions</h1>
        <div className="aboutus-p-container">
          <article>
            <h4>ACCEPTANCE OF TERMS</h4>
            Your use of TheoryDev is subjected to the following terms and
            conditions. Please read it carefully. By using this website of
            TheoryDev, you are deemed to accept and agree our terms and
            conditions and privacy policy.
            <br />
            TheoryDev reserves the sole right to change these Terms & Conditions
            and Privacy Policy any time. Periodical check for any changes made
            in our Terms needs to be done. Using this website after we make any
            alteration to the Terms & Conditions means you agree to accept the
            changes, we are not responsible whether or not you review them. We
            recommend you to NOT use this website if you choose not to accept
            and abide by the Terms & Conditions at any time.
            <br />
            TheoryDev provides software, products and manpower (referred to as
            “SERVICES” collectively) subject to the Client’s acceptance(referred
            to as “Client”) of and compliance with the Terms and Conditions
            (referred to as “Terms”) and the terms of the Service Level
            Assurance (referred to as “SLA”) mentioned below:
            <br />
            <br />
            <h4>SERVICE TERMS</h4>
            The Terms of the Agreement between us will commence on the date that
            you enroll for our Services and will end when terminated by either
            of us in accordance with the Terms and SLA.
            <br />
            TheoryDev has the authority to use its brand name that might come in
            the form of Logo, Design, URL or any types of brand mark to all
            websites produced by us and it will come into force without any
            consent of our customers or clients.
            <br />
            <br />
            <h4>DESCRIPTION OF SERVICES</h4>
            TheoryDev may provide the Client with one or more services, included
            but not mandatorily limited to the following: Website Design &
            Development and affiliated products/services, Maintenance and
            Support Services Content Development or Internet Marketing. Unless
            clearly stated otherwise, any new feature that supplements or boosts
            the Services shall be considered to be part of the
            Services.TheoryDev reserves the right to suspend, modify or
            discontinue the Services (or any part thereof), based on
            non-cooperation, unwanted delay from client or nonpayment at any
            time, without notice. Client should agree that he/she/they, or any
            related third party, shall not hold TheoryDev or its suppliers
            liable for any losses, damages or consequences whatsoever due to
            such alteration, deferment or discontinuation of the Services.
            <br />
            <br />
            <h4>ACCESS TO INFORMATION</h4>
            To access TheoryDev Services or TheoryDev Websites Client may be
            asked to provide relevant details for registration or any other
            information. By accepting these terms, the Client should accept that
            all the information provided by the Client will be correct, current,
            and complete. If TheoryDev believes the information that you has
            provided is not correct, current, or complete, TheoryDev has the
            right to refuse the Client with access to any websites or services
            TheoryDev or any of its resources and to suspend or terminate the
            Client’s account at our convenience.
            <br />
            The calls made or exchanged can be recorded for training and quality
            purposes of the company.
            <br />
            <br />
            <h4>CHANGES TO WEBSITE</h4>
            TheoryDev hereby declares that the organization has sole right to
            change or remove the website (temporarily or permanently) or any
            part of it at any time, without notice. TheoryDev shall not be
            liable to anyone (Client, third-party vendor or user) for any such
            removal or changes.
            <br />
            <br />
            <h4>DATABASE, E-COMMERCE & APPLICATION DEVELOPMENT</h4>
            TheoryDev is not liable for any losses caused by any software that
            we create for the client. Though we take every care to ensure the
            products are accurate and perfect, the final responsibility remains
            with the Client to make sure that all software and products are
            functioning properly before use.
            <br />
            Where applications and site are developed on servers that are not
            provided by TheoryDev, the Client will be responsible to provide
            and/ or seek any, support, information, additional software and/ or
            co-operation relating to the server required for application to be
            developed correctly. For developing large applications, the Client
            will be responsible to provide a suitable testing environment,
            identical to the Client’s final production environment.
            <br />
            Any application or programming with reference to a website developed
            by TheoryDev, the Client should fully test them before making the
            same available for general use. TheoryDev will make an effort but
            not oblige to correct errors, “viruses” or issues of any kind are
            found in the website developed by us after the site is live to meet
            the standards of site’s function highlighted in the brief.
            <br />
            <br />
            <h4>WEBSITE DESIGN</h4>
            TheoryDev will make every effort to ensure that the design of the
            website and any other work done by us is without faults; however,
            TheoryDev will accept any responsibility for losses incurred because
            of malfunction of the website or any other aspect. TheoryDev will be
            the lawful owner of the web server, programming code, content,
            graphics, and any website until the Client clears all outstanding
            accounts in full. Any work done by TheoryDev will remain our
            property and copyright of TheoryDev, unless otherwise agreed, and
            may be commercially reproduced or resold only with the permission of
            TheoryDev.
            <br />
            TheoryDev will not be liable for any copyright infringements that
            are caused due to details submitted by the client.
            <br />
            Any additions to the brief where TheoryDev makes no charge will be
            done at the sole discretion of TheoryDev and for such additions
            TheoryDev will not accept any responsibility to ensure that such
            additions are error free. We reserve the right to charge the Client
            accordingly for any correction to these additions or for further
            additions.
            <br />
            TheoryDev will not be responsible for any loss of earnings,
            compensation or costs incurred due to any work carried out by the
            Client, on behalf of the Client, or by any third-party agents
            appointed by the Client.
            <br />
            TheoryDev is not liable for loss of earnings, compensation or costs
            incurred because of the unavailability of the website, servers,
            software or other material provided by its agents.
            <br />
            <br />
            <h4>COPYRIGHT</h4>
            TheoryDev owns or has the license to or otherwise permitted by law
            to use the copyright, trademarks, and intellectual property rights
            of the site and its content including (but not limited to) the
            graphics ,website design, source codes, text, and all software
            connected with the website.
            <br />
            Using this websites, you are agreeing to access the content only for
            your personal and non-commercial use home use. You cannot download,
            transmit, reproduce, copy, store, distribute or sell the content
            without prior and written consent of TheoryDev.
            <br />
            <br />
            <h4>DISCLAIMERS AND LIMITATIONS OF LIABILITY</h4>
            The website of TheoryDev is provided on an “AS AVAILABLE” and “AS
            IS” basis. We, to the extent permitted by the law, are not
            responsible for any direct, indirect consequential damage or loss
            (including but not limited to loss of business, data, opportunity
            and/ or profit) caused due to the use of the website.
            <br />
            TheoryDev does not guarantee that the website’s functionality will
            be seamless or uninterrupted, that defects will be corrected and/ or
            that the website or server making it available are free of any
            malware or anything else that can be harmful or destructive.
            <br />
            <br />
            <h4>CANCELLATION & REFUND POLICY</h4>
            All amounts owed by the client to TheoryDev for Services provided
            prior to the verified cancellation date must be paid in full. There
            will be no prorating for partial months throughout the Agreement.
            Due to account security and privacy concerns, all billing related
            questions and cancellation requests MUST be made in via email or
            writing.
            <br />
            Cancellation requests for the services will only be processed if
            made by the main authorizing party and only if received in writing.
            There will be no refunds of any currency for any cancellation
            requests made after the cooling-off stage of 3 days from the date of
            order. For security and training purposes, all calls, inbound and
            outbound, made through TheoryDev corporate offices are digitally
            recorded and the recordings form a part of the verbal contract
            between TheoryDev and the client.
            <br />
            Any cancellations done after the cooling-off stage by the client,
            for any reason, will lead to a full payment of the agreed price and
            immediate termination of the contract, unless it is mutually agreed
            between TheoryDev and the Client.
            <br />
            <br />
            <h4>PAYMENT</h4>
            Client agrees to pay TheoryDev the service fee, for any Program or
            Service they enroll themselves in, pursuant to the terms of the
            Payment Plan that the Client selected, including without limitation,
            all applicable taxes, if any, in accordance with the billing terms
            in effect at the time the service fee becomes mandatorily payable.
            Client expressly acknowledges, understands, and hereby authorizes
            TheoryDev to automatically charge Client’s credit card or debit
            Client’s bank account once a month or one time as per the Program
            requirement.
            <br />
            Client will be charged as soon as they sign up over the phone.
            TheoryDev also reserves the right to pursue alternative means of
            payment up to and including debt collection services and customer
            shall be liable for all collection costs, including without
            limitation, attorneys’ fees.
            <br />
            <br />
            <h4>PAYMENT COLLECTION</h4>
            As TheoryDev provides a bill-through service for sponsored listings,
            the company takes a significant credit risk for each and every
            Client. Therefore, the Client is responsible to maintain a valid and
            active payment method on file at all times. If for any reason,
            Client’s payment method is not available, TheoryDev reserves the
            right to immediately and temporarily turn off the website, sponsored
            listings, pay-per-click ads, and ongoing or then current production,
            reporting, or support Services being provided to account. If the
            payment is not received, TheoryDev reserves the right to terminate
            the Agreement in full and retain ownership of the web site, or other
            Services until such time the account has been paid in full. All Term
            Commitment Terminations will result in an escalation of all fees
            owed under the Terms of the Agreement. Many clients maintain
            multiple forms of payment on file to prevent this from occurring.
            Representations and Warranties Client represents, warrants and
            covenants that
            <br /> (i) Client has sufficient authority to enter into the
            Agreement;
            <br /> (ii) Client is a business, not a consumer, and that Client’s
            use of TheoryDev services is solely for lawful commercial and
            business purposes;
            <br />
            (iii) Client has the necessary rights to provide all information
            provided under the Agreement for use as described in the Agreement.
            <br />
            <br />
            <h4>AGREEMENT TO THE POLICY</h4>
            The Client should be aware that while they submit any form of
            personal details to our website, you state your acceptance to the
            terms given above. In case of any queries or verifications you are
            always free to contact us for further assistance.
          </article>
        </div>
              </div>
              </div>
    );
  }
}
